import { Pipe, PipeTransform } from '@angular/core';
import {FormaDePagamento} from "../../../models/enums/FormaDePagamento.enum";

@Pipe({
  name: 'formaPagamento'
})
export class FormaPagamentoPipe implements PipeTransform {

  transform(value: FormaDePagamento): string {
    switch (value) {
      case FormaDePagamento.CARTAO_CREDITO:
        return 'Cartão de crédito';
      case FormaDePagamento.CARTAO_DEBITO:
        return 'Cartão de débito';
      case FormaDePagamento.DINHEIRO:
        return 'Dinheiro';
      case FormaDePagamento.PIX:
        return 'Pix';
    }
    return null;
  }

}
